/* eslint-disable  */
function handleLeaderShipCards() {
  const cards = document.querySelectorAll('.leadership-card');
  if (!cards.length > 0) return;

  const cardsActiveStatus = Array(cards.length).fill(false);

  cards.forEach((card, index) => {
    const btnReadMore = card.querySelector('.btn-read-more');
    const btnCloseBio = card.querySelector('.btn-close-bio');

    if(btnReadMore) {
      btnReadMore.addEventListener('click', () => {
        if (!cardsActiveStatus[index]) {
          closeBios();
          btnReadMore.innerText = 'Read less';
          card.classList.add('active');
          cardsActiveStatus[index] = true;
        } else {
          closeBios();
          cardsActiveStatus[index] = false;
        }
      });
    }
    
    if(btnCloseBio) {
      btnCloseBio.addEventListener('click', closeBios);
    }
  });

  function closeBios() {
    cards.forEach((item) => item.classList.remove('active'));
    cardsActiveStatus.fill(false);
    const readMoreButtons = document.querySelectorAll('.leadership-card .btn-read-more');
    if (readMoreButtons.length > 0) {
      readMoreButtons.forEach((btn) => (btn.innerText = 'Read more'));
    }
  }
}

window.addEventListener('DOMContentLoaded', handleLeaderShipCards);
